'use client'

import { useId } from 'react'
import Link from 'next/link'
import { InputControl, InputLabel, InputMessage } from '@ui/kit'
import { type FieldErrors, type UseFormRegister } from 'react-hook-form'

import { type AuthFormValues } from './form-types'

interface EmailPasswordFieldsProps {
  register: UseFormRegister<AuthFormValues>
  errors: FieldErrors<AuthFormValues>
  showForgotPassword: boolean
}

export const EmailPasswordFields = ({ register, errors, showForgotPassword }: EmailPasswordFieldsProps) => {
  const emailId = useId()
  const passwordId = useId()

  return (
    <div className="text-left">
      <div>
        <InputLabel htmlFor={emailId}>E-Mail</InputLabel>
        <InputControl
          type="email"
          id={emailId}
          placeholder="Адрес электронной почты"
          autoComplete="email"
          view={errors.email ? 'error' : 'default'}
          {...register('email')}
        />
        <InputMessage view={errors.email ? 'error' : 'default'} message={errors.email?.message?.toString()} />
      </div>

      <div>
        <div className="flex items-center justify-between">
          <InputLabel htmlFor={passwordId}>Пароль</InputLabel>
          {showForgotPassword && (
            <Link
              className="link text-sm font-semibold"
              href={{ pathname: '/auth/recovery' }}
              prefetch={false}
              tabIndex={-1}
            >
              Забыли пароль?
            </Link>
          )}
        </div>
        <InputControl
          type="password"
          id={passwordId}
          placeholder="Ваш надёжный пароль"
          autoComplete={showForgotPassword ? 'current-password' : 'new-password'}
          view={errors.password ? 'error' : 'default'}
          {...register('password')}
        />
        <InputMessage view={errors.password ? 'error' : 'default'}>
          {errors.password ? errors.password.message?.toString() : <span>&nbsp;</span>}
        </InputMessage>
      </div>
    </div>
  )
}
